module.exports = __webpack_public_path__ + "474c34cdd5018a0cb5a32b121cf449be.csv";


/*****************
 ** WEBPACK FOOTER
 ** ./client/pages/inventory-variance/samples/Opening.csv
 ** module id = 1304
 ** module chunks = 0
 **/